<div class="login-wrapper">
    @if (introMessage()) {
    <p class="body-large text-center" style="margin-bottom: var(--spacing-l);">
        {{ introMessage() }}
    </p>
    }

    <!-- Login Form -->
    <form [formGroup]="loginForm" (ngSubmit)="onLogin()" class="login-form">
        <app-input [label]="'login.usernameOrEmail' | t" type="text" [placeholder]="'login.usernameOrEmailPlaceholder' | t"
            formControlName="emailOrUsername" iconSrc="assets/icons/email.svg">
        </app-input>

        <app-input [label]="'login.password' | t" type="password" [placeholder]="'login.passwordPlaceholder' | t" formControlName="password"
            iconSrc="assets/icons/shield-check.svg">
        </app-input>

        <div class="push-btn full-width-button primary-color-button btn-m" (click)="onLogin()"
            [class.disabled]="loginForm.invalid || isLoggingIn">
            <div class="inner-button">
                <span class="btn-text p-semibold">{{ isLoggingIn ? ('login.loggingIn' | t) : ('login.loginButton' | t) }}</span>
            </div>
        </div>
    </form>

    <!-- Divider -->
    <div style="display: flex; align-items: center; margin: var(--spacing-l) 0;">
        <div style="flex: 1; height: 1px; background: var(--color-border-secondary);"></div>
        <span style="padding: 0 var(--spacing-m); color: var(--color-text-secondary);" class="p-semibold">{{ 'common.or' | t }}</span>
        <div style="flex: 1; height: 1px; background: var(--color-border-secondary);"></div>
    </div>

    <!-- Custom Google Sign-In Button -->
     <div class="btn-container" style="height: 0; overflow: visible;" >
         <div class="push-btn full-width-button google-signin-btn btn-m primary-invert-color-button" (click)="onGoogleSignIn()"
             [class.loading]="!googleButtonInitialized"
             [class.active]="isGoogleButtonActive">
             <div class="inner-button" [class.active]="isGoogleButtonActive">
                 <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"
                     class="google-icon" [style.display]="isGoogleLoading ? 'none' : ''">
                     <path
                         d="M17.64 9.20443C17.64 8.56625 17.5827 7.95262 17.4764 7.36353H9V10.8449H13.8436C13.635 11.9699 13.0009 12.9231 12.0477 13.5613V15.8194H14.9564C16.6582 14.2526 17.64 11.9453 17.64 9.20443Z"
                         fill="#4285F4" />
                     <path
                         d="M8.99976 18C11.4298 18 13.467 17.1941 14.9561 15.8195L12.0475 13.5613C11.2416 14.1013 10.2107 14.4204 8.99976 14.4204C6.65567 14.4204 4.67158 12.8372 3.96385 10.71H0.957031V13.0418C2.43794 15.9831 5.48158 18 8.99976 18Z"
                         fill="#34A853" />
                     <path
                         d="M3.96409 10.71C3.78409 10.17 3.68182 9.59318 3.68182 9C3.68182 8.40682 3.78409 7.82999 3.96409 7.28999V4.95818H0.957273C0.347727 6.17318 0 7.54772 0 9C0 10.4523 0.347727 11.8268 0.957273 13.0418L3.96409 10.71Z"
                         fill="#FBBC05" />
                     <path
                         d="M8.99976 3.57955C10.3211 3.57955 11.5075 4.03364 12.4402 4.92545L15.0216 2.34409C13.4629 0.891818 11.4257 0 8.99976 0C5.48158 0 2.43794 2.01682 0.957031 4.95818L3.96385 7.29C4.67158 5.16273 6.65567 3.57955 8.99976 3.57955Z"
                         fill="#EA4335" />
                 </svg>
                 @if (isGoogleLoading) {<app-spinner [size]="18" color="current" />}
                 <span class="btn-text p-semibold">{{ isGoogleLoading ? ('login.verifying' | t) : googleButtonInitialized ? ('login.continueWithGoogle' | t) : ('login.googleLoading' | t)
                     }}</span>
             </div>
         </div>
     </div>
    <div #googleSigninButton id="google-signin-button" class='push-btn btn-sm p google-btn' style="justify-content: center; margin-bottom: var(--spacing-m); width: 100%; height: 42px; max-width: 100% !important;" (click)="onGoogleSignIn()">
        <!-- <span class="label">Sign in with:</span> -->
        <!-- <div class="inner-button p ">
        </div> -->
        <!-- SignIn -->
    </div>

    <!-- Hidden Google Button (for triggering) -->
    <!-- <div id="google-signin-button" style="position: absolute; opacity: 0; pointer-events: none; height: 0; overflow: hidden;"></div>
   -->


    <!-- Sign Up Link -->
    <p class="text-center p-semibold" style="margin-top: var(--spacing-m);">
        {{ 'login.noAccount' | t }} <span (click)="goToSignup()"
            style="color: var(--color-primary); cursor: pointer; text-decoration: underline;"> {{ 'login.createAccount' | t }}</span>
    </p>
</div>